import { Box, Flex, Heading, Spacer, Text } from '@chakra-ui/react';

import { InsightsCardDots } from '../../icons';

const InsightsCard = ({
  count,
  underReview,
  overDues,
  onSelect,
  selected = false,
  type = 'all',
  label = '',
}: {
  count: number;
  underReview: number;
  overDues: number;
  onSelect: (type: string) => void;
  selected?: boolean;
  type: string;
  label: string;
}) => (
  <Flex align="center" cursor="pointer" direction="column" mr="20px" onClick={() => onSelect(type)}>
    <Box
      bg={`insightsCard.types.${selected ? 'selected' : 'unSelected'}`}
      h="211px"
      overflow="hidden"
      position="relative"
      rounded="20px"
      w="360px"
      zIndex="1"
    >
      <InsightsCardDots
        bottom="42.17%"
        h="175px"
        left="54.06%"
        opacity={selected ? '0.4' : '0.2'}
        position="absolute"
        right="-15.9%"
        stroke={`insightsCard.types.${selected ? 'unselected' : 'selected'}`}
        top="-18.26%"
        w="175px"
        zIndex="2"
      />
      <Flex direction="column" position="relative" px="20px" py="25px" textAlign="left" zIndex="3">
        <Text
          color={`insightsCard.${selected ? 'color' : 'accentColor'}`}
          fontSize="22px"
          fontWeight="700"
          lineHeight="20px"
          mb="15px"
          textAlign="center"
        >
          {label}
        </Text>
        <Flex align="stretch" height="80px" mb="8px">
          <Flex align="center" direction="column" flex={1} justify="center">
            <Heading color={`insightsCard.${selected ? 'color' : 'accentColor'}`} fontSize="32px" fontWeight="700" textAlign="center">
              {count}
            </Heading>
            <Text color={`insightsCard.${selected ? 'color' : 'accentColor'}`} fontSize="11px" fontWeight="700" textAlign="center">
              Open
            </Text>
          </Flex>
          <Box bg="#818197" opacity="0.4" w="1px" />
          <Flex align="center" direction="column" flex={1} justify="center">
            <Heading color="insightsCard.colorWarning" fontSize="32px" fontWeight="700" textAlign="center">
              {underReview}
            </Heading>
            <Text color="insightsCard.colorWarning" fontSize="11px" fontWeight="700" textAlign="center">
              Under Review
            </Text>
          </Flex>
          <Box bg="#818197" opacity="0.4" w="1px" />
          <Flex align="center" direction="column" flex={1} justify="center">
            <Heading color="insightsCard.colorDanger" fontSize="32px" fontWeight="700" textAlign="center">
              {overDues}
            </Heading>
            <Text color="insightsCard.colorDanger" fontSize="11px" fontWeight="700" textAlign="center">
              Overdue
            </Text>
          </Flex>
        </Flex>
        <Spacer />
      </Flex>
      {selected && <Box bg={`insightsCard.${selected ? 'color' : 'accentColor'}`} h="3px" m="auto" mt="14px" rounded="100px" w="216px" />}
    </Box>
  </Flex>
);

export default InsightsCard;

export const insightsCardStyles = {
  insightsCard: {
    types: {
      selected: '#1E1836',
      unSelected: '#F4F3F5',
    },
    color: '#FFFFFF',
    colorAccent: '#787486',
    accentColor: '#1E1836',
    colorDanger: '#DC0043',
    colorWarning: '#FF9A00',
  },
};
